import {HTMLSelect, Spinner, SpinnerSize} from "@blueprintjs/core";
import * as React from "react";

import {deprecatedCategoryGroup} from "../../../utils/category-util";
import {handleChangeString} from "../../../utils/handle-change";
import {useCategoryCache} from "../category-cache/category-cache";

interface ICategoryGroupSelectorProps {
    slug: string | null;
    emptyOption?: boolean;
    onChange: (slug: string | null) => void;
}

interface ISubCategorySelectorProps extends ICategoryGroupSelectorProps {
    categoryGroupSlug: string;
}

export const CategoryGroupSelector: React.FC<ICategoryGroupSelectorProps> = (props) => {
    const {categoryGroups} = useCategoryCache();

    if (!categoryGroups) {
        return <Spinner size={SpinnerSize.SMALL} />;
    }

    return (
        <HTMLSelect
            value={props.slug || ""}
            onChange={handleChangeString((s) => props.onChange(s === "" ? null : s))}
        >
            <option value="">指定なし</option>
            {categoryGroups.map((x) => (
                <option key={x.groupSlug} value={x.groupSlug}>
                    {x.groupLabel}
                </option>
            ))}
            <option value={deprecatedCategoryGroup}>(廃止されたカテゴリグループ)</option>
        </HTMLSelect>
    );
};

export const SubCategorySelector: React.FC<ISubCategorySelectorProps> = (props) => {
    const {categories} = useCategoryCache();

    if (!categories) {
        return <Spinner size={SpinnerSize.SMALL} />;
    }
    return (
        <>
            <HTMLSelect
                value={props.slug || ""}
                onChange={handleChangeString((s) => props.onChange(s === "" ? null : s))}
                disabled={props.emptyOption}
            >
                <option value="">指定なし</option>
                {categories
                    .filter((x) => props.categoryGroupSlug === x.groupSlug)
                    .map((x) => (
                        <option key={x.slug} value={x.slug}>
                            {x.label}
                        </option>
                    ))}
            </HTMLSelect>
        </>
    );
};
